import { call, put, takeLatest } from "redux-saga/effects";

// action
import {
  GET_APPOINTMENT_LIST,
  getAppointmentListFail,
  getAppointmentListSuccess,
} from "../action/getAppointmentListAction";

// api
import getAppointmentListApi from "../api/getAppointmentListApi";

export function* getAppointmentListSaga(action) {
  try {
    const response = yield call(() => getAppointmentListApi(action.params));
    if (response.data.status === 1) {
      yield put(getAppointmentListSuccess(response, action));
    } else {
      yield put(getAppointmentListFail(response, action));
    }
  } catch (e) {
    yield put(getAppointmentListFail(e.response, action));
  }
}

export default function* mySaga() {
  yield takeLatest(GET_APPOINTMENT_LIST, getAppointmentListSaga);
}
